import { Component, Input, OnInit } from '@angular/core';
import { dataGet } from '../../../support/helpers';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

interface TableListColumn {
    name: string;
    title: string;
    width?: string;
    classes?: string;
    action?: (item?, column?) => void;
}

interface TableListOptions {
    header?: boolean,
    actions?: {
        view?: (((item?) => void) | false)
    }
    columns: Array<TableListColumn>,
};

@Component({
    selector: 'chassis-core-table-list',
    templateUrl: './table-list.component.html',
    styleUrls: ['./table-list.component.scss']
})
export class TableListComponent<T> implements OnInit {

    /**
     * The table options.
     */
    @Input() public options: TableListOptions;

    /**
     * The table items.
     */
    @Input() public items: Observable<Array<T>>;

    /**
     * The table items subject.
     */
    public $items: Subject<Array<T>> = new BehaviorSubject([]);

    public ngOnInit(): void {
        this.items.subscribe((items) => {
            this.$items.next(items);
        });
    }

    /**
     * Get the data of the object for the column.
     *
     * @param object The data object.
     * @param column The table column name.
     */
    public data(object: any, column: string): string | null {
        return dataGet(object ? object : {}, column);
    }

    /**
     * Execute the column action.
     *
     * @param item
     * @param column
     */
    public executeColumnAction(item, column): void {
        if (column.action) {
            column.action(item, column);
            return;
        }

        if (this.options.actions && this.options.actions.view) {
            console.log(this.options.actions.view);
            this.options.actions.view(item);
            return;
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/table-list/table-list.component.ts